import React from 'react';

import { PALETTE } from '../constants';

// IB-677 rework — Overview "Actions by owner": one horizontal stacked flex-div bar
// per owner, segments coloured by the category the action is attached to (risks /
// issues / decisions). Replaces the old Apex bar. Renders bare content — the
// Overview wraps it in a titled card.
const CATEGORIES = () => [
    { key: 'risks', label: $t('Risks'), colour: PALETTE.blue },
    { key: 'issues', label: $t('Issues'), colour: PALETTE.red75 },
    { key: 'decisions', label: $t('Decisions'), colour: PALETTE.charcoal50 },
];

function EmptyState() {
    return (
        <div className="tw-rounded-lg tw-border tw-border-dashed tw-border-charcoal-25 tw-p-4 tw-text-center">
            <div className="tw-mb-1 tw-text-sm tw-font-semibold tw-text-charcoal">{$t('No actions yet')}</div>
            <div className="tw-mx-auto tw-text-xs tw-leading-snug tw-text-charcoal-75" style={{ maxWidth: 280 }}>
                {$t('Actions attached to risks, issues and decisions appear here, grouped by owner.')}
            </div>
        </div>
    );
}

function Swatch({ colour, label }) {
    return (
        <span className="tw-inline-flex tw-items-center tw-gap-1.5">
            <i className="tw-inline-block tw-h-2 tw-w-2 tw-rounded-sm" style={{ background: colour }} />
            {label}
        </span>
    );
}

export default function ActionsByOwnerBars({ dashboardData }) {
    const categories = CATEGORIES();
    const perCategory = {
        risks: dashboardData?.risks?.total_actions_count_by_owner || {},
        issues: dashboardData?.issues?.total_actions_count_by_owner || {},
        decisions: dashboardData?.decisions?.total_actions_count_by_owner || {},
    };

    const owners = Array.from(new Set(Object.values(perCategory).flatMap((counts) => Object.keys(counts)))).filter(Boolean);

    const rows = owners
        .map((owner) => {
            const segments = categories.map((category) => ({ count: Number(perCategory[category.key][owner]) || 0, colour: category.colour }));
            const total = segments.reduce((carry, segment) => carry + segment.count, 0);

            return { owner, segments, total };
        })
        .filter((row) => row.total > 0)
        .sort((a, b) => b.total - a.total);

    if (!rows.length) {
        return <EmptyState />;
    }

    const max = Math.max(1, ...rows.map((row) => row.total));

    return (
        <div>
            <div className="tw-flex tw-flex-col tw-gap-2">
                {rows.map((row) => (
                    <div key={row.owner} className="tw-grid tw-items-center tw-gap-2 tw-text-xs" style={{ gridTemplateColumns: '120px 1fr 34px' }}>
                        <div className="tw-truncate tw-font-medium tw-text-charcoal-75">{row.owner}</div>
                        <div className="tw-flex tw-h-3 tw-overflow-hidden tw-rounded tw-bg-grey">
                            {row.segments.map((segment, index) => (
                                <div key={index} style={{ width: `${(segment.count / max) * 100}%`, background: segment.colour }} />
                            ))}
                        </div>
                        <div className="tw-text-end tw-font-semibold tw-text-charcoal">{row.total}</div>
                    </div>
                ))}
            </div>
            <div className="tw-mt-3 tw-flex tw-flex-wrap tw-gap-x-4 tw-gap-y-1 tw-text-2xs tw-text-charcoal-50">
                <span>{$t('Attached to')}:</span>
                {categories.map((category) => (
                    <Swatch key={category.key} colour={category.colour} label={category.label} />
                ))}
            </div>
        </div>
    );
}
